/** `errorCode` do stream que fechou sem `complete`, `error` nem pausa. */
export const STREAM_INTERRUPTED_CODE = "stream_interrupted";

/** `errorCode` da falha de rede, sem resposta HTTP. */
export const STREAM_TRANSPORT_ERROR_CODE = "stream_transport_error";
